import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { CREATE_SLIDE, CREATE_SLIDE_FAIL, CREATE_SLIDE_SUCCESS, CreateSlideAction } from '../redux/manageSlidesReducer'
import { Slide } from '../types'

function* CreateSlideFlow(action: CreateSlideAction): Generator<any, void, any> {
  try {
    const response: Slide = yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/slides`,
      method: 'POST',
      params: {}
    })

    yield put(CREATE_SLIDE_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, slide: response }))
  } catch (error) {
    yield put(CREATE_SLIDE_FAIL())
    console.log(error)
  }
}

export default function* CreateSlideSaga(): Generator<any, void, any> {
  yield takeLatest([CREATE_SLIDE], CreateSlideFlow)
}
